export default __webpack_public_path__ + "static/media/roadmap.e2df5b27.svg";